import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Navigation from './navigation';
import { CommunicationService } from './services/communication-service';
import SessionTimeout from './idle-session-timeout/SessionTimeout';
import { useHistory } from "react-router-dom";
import './styles';
// import "react-datepicker/dist/react-datepicker.css";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

function App(props) {
  const history = useHistory();
  const [isAuthenticated, setAuth] = useState(false);

  useEffect(() => {
  
    if (localStorage.getItem("ACCESS_TOKEN"))
      setAuth(true)

    const subscription = CommunicationService.getLoggedInSatus().subscribe(status => {
      if (status) {
        setAuth(true)
      }
    });

    return subscription.unsubscribe;
  }, [props]);

  const handleClick = () => {
    setAuth(false)
    localStorage.removeItem("ACCESS_TOKEN");
    localStorage.removeItem("REFRESH_TOKEN");
    localStorage.removeItem("loginUser");
    localStorage.clear()
    history.push('/login')
  }
  return (
    <div>
      <SessionTimeout isAuthenticated={isAuthenticated} logOut={handleClick} />
      <Navigation />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    values: state.values.profile
  }
}

export default connect(mapStateToProps)(App);
